<template>
  <section class="hero is-fullheight-with-navbar is-fullheight-with-spaced-navbar jumbotron">
    <div class="hero-body">
      <div class="columns is-vcentered is-variable is-8">
        <div class="column is-half-tablet is-full-mobile graphics-column">
          <home-graphic v-if="this.uid == 'home'" />
        </div>
        <div v-scroll-reveal="{ delay: 30 }" class="column load-hidden is-half">
          <h1 :key="0" class="title">{{ $prismic.richTextAsPlain(slice.primary.jumbotron_headline) }}</h1>
          <br/>
          <prismic-rich-text :field="slice.primary.jumbotron_content"/>
          <br/>
          <div :key="1" v-if="slice.primary.jumbotron_button_text">
            <prismic-link :field="slice.primary.jumbotron_button_link" class="button is-uppercase">{{ $prismic.richTextAsPlain(slice.primary.jumbotron_button_text) }}</prismic-link>
          </div>
        </div>
      </div>
      <!-- <div class="container">
        <home-graphic v-if="this.uid == 'home'" />
        <div v-scroll-reveal="{ delay: 30 }" class="column is-offset-half load-hidden">
          <h1 :key="0" class="title">{{ $prismic.richTextAsPlain(slice.primary.jumbotron_headline) }}</h1>
          <br/>
          <prismic-rich-text :field="slice.primary.jumbotron_content"/>
          <br/>
          <div :key="1" v-if="slice.primary.jumbotron_button_text">
            <prismic-link :field="slice.primary.jumbotron_button_link" class="button is-uppercase">{{ $prismic.richTextAsPlain(slice.primary.jumbotron_button_text) }}</prismic-link>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import HomeGraphic from '../HomeGraphic.vue'

export default {
  name: 'Jumbotron',
  props: ['slice', 'uid'],
  components: {
    HomeGraphic,
  }
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../../assets/sass/colors.scss";

.hero.jumbotron {
  background-position: 0% center;
  background-size: 40%;
  background-repeat: no-repeat;
  position: relative;
  &.left {
    background-position: 100% center;
  }
  &.right {
    background-position: 0% center;
  }
  @media screen and (max-width: $tablet) {
    background-image: none !important;
  }
}

.graphics-column {
  text-align: right;
  width: 100% !important;
  margin-left: -50%;
  @media screen and (max-width: $tablet) {
    margin-left: 0;
  }
}

// .hero.jumbotron {
//   background-image: url('~@/assets/img/jumbotron.jpg');
//   background-position: 50% 100%;
//   background-size: cover;
//   background-repeat: no-repeat;
//   position: relative;

//   &:before {
//     content: '';
//     position: absolute;
//     background: $white;
//     opacity: 0.7;
//     width: 100%;
//     height: 100%;
//   }
// }

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
